import { purple, yellow } from '@material-ui/core/colors'
import { createMuiTheme } from '@material-ui/core/styles'

const themes = {
  darkTheme: createMuiTheme({
    palette: {
      type: 'dark',
      primary: {
        main: purple[800],
      },
      secondary: {
        main: "#ffeb3b",
      },
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '*': {
            'scrollbar-width': 'thin',
          },
          '*::-webkit-scrollbar': {
            width: '4px',
            height: '4px',
          },
        },
      },
    },
  }),
  lightTheme: createMuiTheme({
    palette: {
      type: 'light',
      primary: {
        main: purple[400],
      },
      secondary: {
        main: yellow[700],
      },
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '*': {
            'scrollbar-width': 'thin',
          },
          '*::-webkit-scrollbar': {
            width: '4px',
            height: '4px',
          },
        },
      },
    },
  }),
}

export default themes
